import { buildOptionsFromData } from 'works/components/filtered-table';

type EmploymentType = { name: string; description: string };

export function handleEmploymentTypeFilter(
  employmentTypesData: { enum: EmploymentType[] } | undefined
) {
  const optionsData = employmentTypesData ? [...employmentTypesData.enum] : [];

  return buildOptionsFromData(
    optionsData,
    ({ description, name }: EmploymentType) => ({
      text: description,
      value: name,
    }),
    ({ name }: EmploymentType) => name,
    ({ description }: EmploymentType) => description
  );
}
